import { CommonModule } from "@angular/common";
import { Component, OnDestroy, OnInit, output } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter, Subscription, Observable } from "rxjs";
import { MenuItem } from "primeng/api";
import { MenuModule } from "primeng/menu";
import {
  SessionData,
  SessionService,
} from "../../../../Utils/_services/session/session.service";
import { environment } from "../../../../environments/environment";

@Component({
  selector: "app-header",
  standalone: true,
  imports: [CommonModule, MenuModule],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.css",
})
export class HeaderComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private sessionService: SessionService
  ) {}

  toggleSidebar = output<void>();
  pageTitle = "";
  private sub?: Subscription;
  sessionData!: SessionData | null;

  menuItems: MenuItem[] = [];
  ngOnInit(): void {
    this.computePageTitle();
    this.sub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(() => this.computePageTitle());

    this.sessionService.sessionData$.subscribe(data => {
      this.sessionData = data;
    });

    this.menuItems = [
      {
        label: "Profile",
        icon: "pi pi-user",
        command: () => this.goToProfile(),
      },
      {
        separator: true,
      },
      {
        label: "Go Home",
        icon: "pi pi-home",
        command: () => this.goHome(),
      },
      {
        separator: true,
      },
      {
        label: "Go PWA",
        icon: "pi pi-desktop",
        command: () => this.goPWA(),
      },
      {
        separator: true,
      },
      {
        label: "Logout",
        icon: "pi pi-sign-out",
        command: () => this.logout(),
      },
    ];
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  get greeting(): string {
    const h = new Date().getHours();
    if (h < 12) return "Good Morning";
    if (h < 17) return "Good Afternoon";
    return "Good Evening";
  }

  get breadcrumb(): string {
    return `Admin / ${this.pageTitle}`;
  }

  private computePageTitle(): void {
    const url = this.router.url || "";
    const segments = url.split("?")[0].split("#")[0].split("/").filter(Boolean);
    // Prefer last meaningful segment as title
    const last = segments[segments.length - 1] || "";
    this.pageTitle = this.toTitleCase(last.replace(/[-_]/g, " "));
  }

  private toTitleCase(s: string): string {
    return s
      .split(" ")
      .filter(Boolean)
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(" ");
  }

  private goHome() {
    this.router.navigate(["/"]);
  }

  private goPWA() {
    // GET JWT and user data to forward to PWA login
    const userData = this.sessionService.getCurrentUser();
    if (userData) {
      const adoreTheBallonUrlPlusJwt = `${environment.pwaFrontendBaseUrl}/login?id=${encodeURIComponent(userData.uuidv4Id)}`;
      window.open(adoreTheBallonUrlPlusJwt, "_blank");
    }
  }

  private logout() {
    try {
      this.sessionService.clearSession();
    } catch (err) {
      console.warn("Error clearing session on logout", err);
    }
    this.router.navigate(["/auth/login"]);
  }

  private goToProfile() {
    this.router.navigate(["/admin/profile"]);
  }
}
